var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.isMobileUser && _vm.phoneType === "SPH"
        ? _c(
            "custom-btn-dialog",
            {
              ref: "dialog",
              attrs: {
                "btn-text": _vm.generateMessage("tech_search.transmit"),
                width: "600px",
                color: "info",
                title: _vm.generateMessage("requests.actions.transmission"),
                icon: _vm.icon
              },
              on: { change: _vm.getCustomerComment },
              scopedSlots: _vm._u(
                [
                  {
                    key: "actions",
                    fn: function() {
                      return [
                        _c(
                          "v-btn",
                          {
                            staticClass: "mx-2",
                            attrs: {
                              small: "",
                              disabled: _vm.textTooLong,
                              color: "info",
                              loading: _vm.isUploading
                            },
                            on: { click: _vm.transmit }
                          },
                          [
                            _vm._v(
                              "\n        " +
                                _vm._s(
                                  _vm.generateMessage("requests.actions.yes")
                                ) +
                                "\n      "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            staticClass: "mx-2",
                            attrs: { small: "" },
                            on: { click: _vm.cancel }
                          },
                          [
                            _vm._v(
                              "\n        " +
                                _vm._s(
                                  _vm.generateMessage("requests.actions.no")
                                ) +
                                "\n      "
                            )
                          ]
                        )
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                4101687931
              )
            },
            [
              _c(
                "loader",
                { attrs: { "is-loading": _vm.isLoading } },
                [
                  _c(
                    "v-snackbar",
                    {
                      attrs: { centered: "", color: _vm.snackbar.color },
                      model: {
                        value: _vm.snackbar.open,
                        callback: function($$v) {
                          _vm.$set(_vm.snackbar, "open", $$v)
                        },
                        expression: "snackbar.open"
                      }
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.snackbar.message) + "\n      "
                      )
                    ]
                  ),
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.generateMessage("tech_search.affected_tech_message")
                      ) +
                      "\n      " +
                      _vm._s(_vm.name) +
                      "\n      "
                  ),
                  _c("custom-text-area", {
                    staticClass: "mx-2",
                    attrs: {
                      "max-character": 1023,
                      "error-too-long-msg": _vm.generateMessage(
                        "tech_search.comment_too_long"
                      ),
                      label: _vm.generateMessage(
                        "requests.fields.customer_comment"
                      )
                    },
                    model: {
                      value: _vm.text,
                      callback: function($$v) {
                        _vm.text = $$v
                      },
                      expression: "text"
                    }
                  }),
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.generateMessage("tech_search.transmit_question")
                      ) +
                      "\n    "
                  )
                ],
                1
              )
            ],
            1
          )
        : _c(
            "v-btn",
            {
              staticClass: "d-flex justify-start",
              attrs: { disabled: "", small: "", text: "", color: "info" }
            },
            [
              _c("v-icon", { attrs: { left: "" } }, [_vm._v(_vm._s(_vm.icon))]),
              _vm._v(
                "\n    " +
                  _vm._s(_vm.generateMessage("tech_search.transmit")) +
                  "\n  "
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }